import { apiClient } from './api'

export type ServiceName = 'BLIS' | 'IZG'

export interface UsageMetric {
  metric_name: string
  count: number
  limit?: number
  period_start: string
  period_end: string
  last_reset_at?: string
  percentage_used?: number
}

export interface ServiceUsage {
  service_name: ServiceName
  metrics: UsageMetric[]
  subscription_status?: string
  plan_tier?: string
}

export interface UsageResponse {
  organization_id: string
  services: ServiceUsage[]
  total_usage: Record<string, number>
}

export interface UsageIncrementRequest {
  service_name: ServiceName
  metric_name?: string
  amount?: number
  metadata?: Record<string, unknown>
}

export interface UsageIncrementResponse {
  success: boolean
  current_count: number
  limit?: number
  limit_exceeded: boolean
  message: string
}

export interface UsageLogEntry {
  log_id: string
  service_name: ServiceName
  action_type: string
  timestamp: string
  metadata?: Record<string, unknown>
}

export interface UsageHistoryResponse {
  organization_id: string
  logs: UsageLogEntry[]
  total: number
  period_start?: string
  period_end?: string
}

export const usageService = {
  // Get current usage
  getCurrentUsage: async (
    organizationId: string,
    serviceName?: ServiceName
  ): Promise<UsageResponse> => {
    const response = await apiClient.get<UsageResponse>(
      `/usage/${organizationId}`,
      {
        params: serviceName ? { service_name: serviceName } : undefined,
      }
    )
    return response.data
  },

  // Get usage history
  getUsageHistory: async (
    organizationId: string,
    params?: {
      service_name?: ServiceName
      limit?: number
      offset?: number
    }
  ): Promise<UsageHistoryResponse> => {
    const response = await apiClient.get<UsageHistoryResponse>(
      `/usage/${organizationId}/history`,
      { params }
    )
    return response.data
  },

  // Increment usage (internal)
  incrementUsage: async (
    organizationId: string,
    data: UsageIncrementRequest
  ): Promise<UsageIncrementResponse> => {
    const response = await apiClient.post<UsageIncrementResponse>(
      `/usage/${organizationId}/increment`,
      data
    )
    return response.data
  },
}

